/**
 * Single source of truth for the API base URL.
 *
 * Dev: ``VITE_API_BASE_URL`` is unset → empty string → requests stay
 * relative and go through the Vite proxy (``/api/v1``, ``/auth``, ``/output``
 * forwarded to ``localhost:${BACKEND_PORT}``, default 8765 — see
 * ``vite.config.ts``).
 *
 * Prod: the Cloudflare Pages build sets
 * ``VITE_API_BASE_URL=https://dev-api-prism.lcprojects.com.br`` (the skab's
 * tunnel; ``api-prism`` isn't live — it answered 530 on 2026-09-29) → all
 * helpers and ``fetch`` callers prepend it so the SPA on
 * ``prism.lcprojects.com.br`` reaches the backend through the tunnel.
 *
 * Never include a trailing slash — every consumer concatenates a path
 * that already starts with ``/``.
 */
export const API_BASE_URL: string =
  ((import.meta.env.VITE_API_BASE_URL as string | undefined) ?? '').replace(/\/+$/, '')

/**
 * Resolve a relative API path against ``API_BASE_URL``. Pass-through for
 * absolute URLs (``http(s)://``) so consumers can hand third-party links
 * to the same helper without surprising prefixing.
 */
export function apiUrl(path: string): string {
  if (/^https?:\/\//i.test(path)) return path
  if (!API_BASE_URL) return path
  return path.startsWith('/') ? `${API_BASE_URL}${path}` : `${API_BASE_URL}/${path}`
}
